export default "__VITE_ASSET__95f3d69d__"